/*
 * @Author: zhangyang yang.zhang@corerain.com
 * @Date: 2023-02-22 10:52:35
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-08 14:42:12
 * @FilePath: \cr-vplan\src\directives\permission.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { ObjectDirective, toRaw } from 'vue'
import store from '@/store'

const permission: ObjectDirective = {
  mounted(el, binding) {
    const btnList = toRaw(store.state.user.accessButtons)
    const pageAllButtons = toRaw(store.state.user.pageAllButtons)
    const bindingVal = binding.value
    if (bindingVal === '') {
      return
    }

    if (!btnList.includes(bindingVal) && pageAllButtons.includes(bindingVal)) {
      const parentNode = el.parentNode
      parentNode && parentNode.removeChild(el)
    }
  }
}

export default permission
